import { Component, OnInit } from '@angular/core';
import { UserService } from 'app/shared/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'app/shared/services/dialog.service';
import { AuthService } from 'app/shared/services/auth.service';
import { Router} from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { NbThemeService, NB_THEME_OPTIONS } from '@nebular/theme';




@Component({
  selector: 'app-user-permission',
  templateUrl: './user-permission.component.html',
  styleUrls: ['./user-permission.component.css']
})
export class UserPermissionComponent implements OnInit {

  userList: any[];
  userPermission : any;
  userControlPermission: any;
  selectedUser : string ;
  selectedUserForControl : string =null;
  isSaveBtnDisabled: boolean = false;
  isDeleteBtnDisabled: boolean = false;
  showProcessingIndicator = false;
  isDark: boolean = false;

  controlPermissionArray =[];
  selectAll : boolean = false;

  selectAllPermission : boolean = false;
 
  typesOfUI: string[] = [`Dashboard`,`Company Profile`,  `Employee Master`,`Supplier Master`, `Customer Master`,`Room Details`, `Fixed Asset`, `Vehicle Register`,
  `Item Category`, `Item Master`, 
  `Kitchen Stock`,  `Add Kitchen Stock`,`Daily Consumption`,  `Kitchen Stock Balance`,`Stock Requirement`, 
  `Solar Power Mgt`,`Water Meter Reading`,`Bike Rent`, `Generator Usage`,
  `Purchase Order`, `Purchase Invoice`,`Payment`, 
  `Bar Invoice`, `Quotation`, `Guest Purchase`,`Invoice`, `Receipt`,
  `Expenses`, `Manage Account`,`Cash & Bank Entry`,`Cheques`,`Cash & Bank Balances`,
  `Customer Outstanding Report`, `Supplier Outstanding Report`,  `Inventory Balance Report`,`Purchase Report`, `Sales Report`,  `Bar Sales Report`, `Item Sales Report`, `Expenses Report`, `Consumption Report`, `Fixed Asset Report`,`Profit & Loss Statement`,
  `User Management`, `Settings`,`Backup`];

  
  selectedUI :  string[]=[];

  allUI :  number[] =[];
   id : number;

  constructor(private userService : UserService, 
              private toastr: ToastrService, 
              private dialogService: DialogService,
              private router : Router,
              private authService: AuthService,
              private themeService: NbThemeService,
            ) { }

  ngOnInit(): void {

    this.getUserList();
    this.initializeControlPermissions();

    this.userPermission = {
      userName : '',
      upArray : [],
      createdBy :'',
     }


     this.themeService.onThemeChange()
     .subscribe(themeName =>{
          this.isDark  = themeName.name ==='dark' ? true : false;
         });

    }

   


 
    initializeControlPermissions(){
      this.controlPermissionArray = [
        {moduleCode :'COM',module : "Company Profile", read : 0, create : 0, approve : null, delete : null},
        {moduleCode :'SM',module : "Supplier Master", read : 0, create : 0, approve : null, delete : 0},
        {moduleCode :'CM',module : "Customer Master", read : 0, create : 0, approve : null, delete : 0},
        {moduleCode :'EM',module : "Employee Master", read : 0, create : 0, approve : null, delete : 0},
        {moduleCode :'RD',module : "Room Details", read : 0, create : 0, approve : null, delete : 0},
        {moduleCode :'FA',module : "Fixed Asset", read : 0, create : 0, approve : null, delete : 0},
        {moduleCode :'VH',module : "Vehicle Register", read : 0, create : 0, approve : null, delete : 0},

        {moduleCode :'IC',module : "Item Category", read : 0, create : 0, approve : null, delete : 0},     
        {moduleCode :'IM',module : "Item Master", read : 0, create : 0, approve : null, delete : 0},

        {moduleCode :'KS',module : "Kitchen Stock", read : 0, create : 0, approve : null, delete : 0},     

        {moduleCode :'SP',module : "Solar Poweer Mgt", read : 0, create : 0, approve : null, delete : 0},
        {moduleCode :'WM',module : "Water Meter Reading", read : 0, create : 0, approve : null, delete : 0},
        {moduleCode :'BR',module : "Bike Rent", read : 0, create : 0, approve : null, delete : 0},
        {moduleCode :'GU',module : "Generator Usage", read : 0, create : 0, approve : null, delete : 0},
       
        {moduleCode :'PO',module : "Purchase Order", read : 0, create : 0, approve : null, delete : 0},
        {moduleCode :'PI',module : "Purchase Invoice", read : 0, create : 0, approve : null, delete : 0},
        {moduleCode :'PMT',module : "Payment", read : 0, create : 0, approve : null, delete : 0},

        {moduleCode :'BAR',module : "Bar Invoice", read : 0, create : 0, approve : null, delete : 0},
        {moduleCode :'QUO',module : "Quotation", read : 0, create : 0, approve : null, delete : 0},
        {moduleCode :'INV',module : "Invoice", read : 0, create : 0, approve : null, delete : 0},
        {moduleCode :'RECEIPT',module : "Receipt", read : 0, create : 0, approve : null, delete : 0},

        {moduleCode :'EXP',module : "Expenses", read : 0, create : 0, approve : null, delete : 0},
        {moduleCode :'MACC',module : "Manage Account", read : 0, create : 0, approve : null, delete : 0},
        {moduleCode :'CB',module : "Cash & Bank Entry", read : 0, create : 0, approve : null, delete : 0},

        {moduleCode :'FILE',module : "File Upload", read : 0, create : 0, approve : null, delete : 0},
     
      ]
     
     }

     checkedAllControlPermissions(){
      this.controlPermissionArray.forEach(key=>{
        key.read = 1;
        key.create = 1;
        if(key.approve !=null){
          key.approve = 1;
        }
        if(key.delete !=null){
          key.delete = 1;
        }
      });
     }


     selectAllPermissioncheckedChange(){ 
      this.selectedUI = [];
      if(this.selectAllPermission){  
        this.selectedUI= this.typesOfUI
      }
    }

  getUserList(){
    this.userService.getAll()
     .subscribe(
        (data) => {
                  this.userList = data;
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });  
       
     }



  saveButtonClick(): void {
    var data: any;
    this.allUI = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
    this.showProcessingIndicator = true;
    for(let i = 0; i <  this.typesOfUI.length; i++){    
      for(let x = 0; x <  this.selectedUI.length; x++){
        if(this.typesOfUI[i] ===this.selectedUI[x]){
          this.allUI[i] = 1;         
        }
      }
    }

    if(this.selectedUser){

      if(this.id===0){
        this.userPermission.userName = this.selectedUser;
        this.userPermission.upArray = this.allUI;
        this.userPermission.createdBy = this.authService.getUserLoggedIn();
        this.userService.addUserPermission(this.userPermission)
        .subscribe(
          (res)=> {
            data = res;
            this.toastr.success('User permission granted', 'Success');   
            this.showProcessingIndicator = false;
            this.selectedUI = [];
            this.selectedUser = undefined;
            this.selectAllPermission=false;
           
          },
          (err) => {
            this.toastr.error('Failed to grant user permission', 'Failure');
            this.showProcessingIndicator = false;
            if(err instanceof HttpErrorResponse){                 
              if(err.status == 401){
                this.router.navigate(['/login']);
              }
            }
            console.log(err);
          },
          )
      }else{

        this.dialogService.openConfirmDialog('Are you sure you want to update user permission')
        .afterClosed().subscribe(res => {
          if (res) {
            this.userPermission.userName = this.selectedUser;
            this.userPermission.upArray = this.allUI;
            this.userPermission.createdBy = this.authService.getUserLoggedIn();
            this.userService.updateUserPermission(this.userPermission)
              .subscribe(
                (res) => {
                  this.toastr.success('User permission updated successfully', 'Success');
                  this.showProcessingIndicator = false;
                  this.selectedUI = [];
                  this.selectedUser = undefined;
                  this.selectAllPermission=false;
                },
                (err) => {
                  this.toastr.error('Failed to update user permission', 'Failure');
                  this.showProcessingIndicator = false;
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                },
              )
          }else{
            this.showProcessingIndicator = false;
          } 
        })

      }
  
     }else{
      this.toastr.warning('User not selected', 'Warning');
      this.showProcessingIndicator = false;
     }
 

    } 


    mapControlsValues(){
      this.controlPermissionArray.forEach(key=>{
        key['username']=this.selectedUserForControl;
        key['createdBy']=this.authService.getUserLoggedIn();
      })

      var data = this.controlPermissionArray.map(val =>{
        return [val.username,val.moduleCode,val.module,val.read,val.create,val.approve,val.delete,val.createdBy]
      })
      
      return data;
     }

    saveControlPermissionButtonClick(): void {

      var getData = this.mapControlsValues();

      if(this.selectedUserForControl){

          this.userService.addControlPermission(getData)
          .subscribe(
            (res)=> {
              this.toastr.success('User control permission granted', 'Success');    
              console.log(res);  
              this.showProcessingIndicator = false;
              
            },
            (err) => {
              this.toastr.error('Failed to grant user permission', 'Failure');
              this.showProcessingIndicator = false;
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err);
            },
            )    
    
       }else{
        this.toastr.warning('User not selected', 'Warning');
        this.showProcessingIndicator = false;
       }
   
  
      } 




  getUserPermissionByUserName(){
   this.id = 0;
    var data = [];
    this.selectedUI = [];

    if(this.selectedUser){
      this.userService.getUserPermission(this.selectedUser).subscribe(
        (res)=> {
          if(res[0]){
            this.id = res[0].Id
            const values = Object.values(res[0])
            for (var value of values) {
              data.push(value);                                                  
            }
  
            data = data.slice(2,49)
              for(let i = 0; i < data.length; i++){                       
                if(data[i]===1){
                  this.selectedUI.push(this.typesOfUI[i]) 
                  }               
               } 
               
              this.selectedUI  = [ ...this.selectedUI] 
          }        
   
                       
        },
        (err) => {
          this.toastr.error('Failed to load data', 'Failure');
          if(err instanceof HttpErrorResponse){                 
            if(err.status == 401){
              this.router.navigate(['/login']);
            }
          }
          console.log(err);
        },

      )
    }
       
  }

  getUserControlPermissionByUserName(){
    this.initializeControlPermissions();

    if(this.selectedUserForControl){
      this.userService.getControlPermission(this.selectedUserForControl).subscribe(
        (res)=> { 
          if(res.length > 0){
              this.controlPermissionArray= res.map((obj)=> {
              return {username: obj.UserName,
                      moduleCode : obj.ModuleCode,
                      module: obj.Module,
                      read: obj.ReadAccess==='0'? 0: obj.ReadAccess,
                      create: obj.CreateAccess==='0' ? 0: obj.CreateAccess, 
                      approve:  obj.ApproveAccess==='0' ? 0: obj.ApproveAccess,  
                      delete: obj.DeleteAccess==='0' ? 0: obj.DeleteAccess,
                      createdBy: obj.CreatedBy
                    };
              }); 
           
            }else{
              this.initializeControlPermissions();
            } 
           
        },
        (err) => {
          this.toastr.error('Failed to load data', 'Failure');
          if(err instanceof HttpErrorResponse){                 
            if(err.status == 401){
              this.router.navigate(['/login']);
            }
          }
          console.log(err);
        },

      )
    }
       

  }
  
  selectAllcheckedChange(){ 
    this.initializeControlPermissions();
    if(this.selectAll){
      this.checkedAllControlPermissions();
    }
  }

  clearPanel(){
    this.selectedUserForControl = null;
    this.selectAll = false;
    this.initializeControlPermissions();
  }

  deleteButtonClick(): void {

    if(this.selectedUser){

      if(this.id!==0){
        this.dialogService.openConfirmDialog('Are you sure you want to delete all permission granted to this user')
        .afterClosed().subscribe(res => {
          if (res) {
            this.userService.deleteUserPermission(this.id)
              .subscribe(
                (res) => {
                  this.toastr.success('All permission deleted successfully', 'Success');
                  this.selectedUI = [];
                  this.selectedUser = undefined;
                  this.selectAllPermission=false;
                  console.log(res);
                },
                (err) => {
                  this.toastr.error('Failed to delete user permission', 'Failure');
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                },
              )
          } 
        })

      }
  
     }else{
      this.toastr.warning('User not selected', 'Warning');
     }

  }


  deleteControlPermissionButtonClick(): void {

    if(this.selectedUserForControl){

        this.dialogService.openConfirmDialog('Are you sure you want to delete all control permission granted to this user')
        .afterClosed().subscribe(res => {
          if (res) {
            this.userService.deleteControlPermission(this.selectedUserForControl)
              .subscribe(
                (res) => {
                  this.toastr.success('Deleted successfully', 'Success');
                  this.selectedUI = [];
                  this.selectedUser = undefined;
                  this.selectAll = false;
                  this.initializeControlPermissions();
                  console.log(res);
                },
                (err) => {
                  this.toastr.error('Failed to delete permission', 'Failure');
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                },
              )
          } 
        })
     
     }else{
      this.toastr.warning('User not selected', 'Warning');
     }

  }


} //end class
